import {
  UPLOAD_FOTOS_SUCCESS,
  UPLOAD_FOTOS_FAIL,
  LOAD_FOTOS_SUCCESS,
  LOAD_FOTOS_FAIL,
  DELETE_FOTO_SUCCESS,
  DELETE_FOTO_FAIL,
  START_LOADING,
  STOP_LOADING,
} from "../actions/foto";

const initialState = {
  fotos: [],
  loading: false,
  error: null,
  page: 1,
  totalPages: 1,
  total: 0,
  limit: 30,
};

const fotoReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, loading: true };

    case STOP_LOADING:
      return { ...state, loading: false };

    case UPLOAD_FOTOS_SUCCESS:
      return {
        ...state,
        fotos: [...state.fotos, ...action.payload],
        total: state.total + action.payload.length,
        error: null,
        loading: false,
      };

    case UPLOAD_FOTOS_FAIL:
      return { ...state, error: action.payload, loading: false };

    case LOAD_FOTOS_SUCCESS:
      return {
        ...state,
        fotos: action.payload?.items || [],
        page: action.payload?.page || 1,
        totalPages: action.payload?.totalPages || 1,
        total: action.payload?.total || 0,
        limit: action.payload?.limit || 30,
        error: null,
        loading: false,
      };

    case LOAD_FOTOS_FAIL:
      return {
        ...state,
        fotos: [],
        page: 1,
        totalPages: 1,
        total: 0,
        error: action.payload,
        loading: false,
      };

    case DELETE_FOTO_SUCCESS:
      return {
        ...state,
        fotos: state.fotos.filter((foto) => foto.id !== action.payload),
        total: Math.max(state.total - 1, 0),
        error: null,
        loading: false,
      };

    case DELETE_FOTO_FAIL:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};

export default fotoReducer;
